import { dynamicImport, isPresent as isComponentPresent } from "components-utils";
import StructureComponents from "barcelo-components/structure";
import HotelComponents from "barcelo-components/hotel";
import GenericComponents from "barcelo-components/generic";
import ListingComponents from "barcelo-components/listing";
import AdvComponents from "barcelo-components/adv";
import MenuComponents from "barcelo-components/menu";
import VariousComponents from "barcelo-components/various";
import TeasersComponents from "barcelo-components/teasers";
import FaqComponents from "barcelo-components/faq";
import MyBarceloComponents from "barcelo-components/mybarcelo";

const components = {
  ...AdvComponents,
  ...StructureComponents,
  ...HotelComponents,
  ...GenericComponents,
  ...ListingComponents,
  ...MenuComponents,
  ...VariousComponents,
  ...TeasersComponents,
  ...FaqComponents,
  ...MyBarceloComponents,
};
// eslint-disable-next-line func-style
export function BarceloComponent({ selector, path, initMethod = "init", skipInit = false, belongsTo = "", customName = "", forceImport = false }) {
  return {
    forceImport,

    isPresent: ({ root = document, ignoreForceImport = false, ignoreIsPresent = false } = {}) => {
      return ignoreIsPresent || (!ignoreForceImport && forceImport) || isComponentPresent(selector, root);
    },

    importComponent: async ({ name, root }) => {
      const component = await import(`./${path}.js`);
      return dynamicImport({
        customName,
        name,
        component,
        skipInit,
        belongsTo,
        initMethod,
        root,
      });
    },

    componentClass: () => ({
      selector,
    }),
  };
}

export default components;
